<template>
  <div class="content">
    <img :src="public_path + '/static/images/success_icon@3x.png'" alt="" class="success">
    <p class="submit-success">提交成功</p>
    <p class="checking">认证审核中</p>
    <p class="hint">预计两个工作日内将联系您线下签约，期间请保持电话通畅</p>
  </div>
</template>
<script>
import { getInfo } from '@/http/api'
export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH
    }
  },
  methods: {
    getUserInfo () {
      let data = {
        token: localStorage.token
      }
      getInfo(data).then(res => {
        console.log(res)
        if (res.code === 0) {
          console.log(res.data.state)
          if (+res.data.state === 0 || +res.data.state === 10) {
            this.$router.push({
              path: '/apply'
            })
          } else if (+res.data.state === 11) {
          } else {
            this.$router.push({
              path: '/'
            })
          }
        } else {
          console.log('请求服务商信息失败')
          localStorage.clear()
          this.$router.push({
            path: '/login'
          })
        }
      })
    }
  },
  mounted () {
    this.getUserInfo()
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  .success {
    display: block;
    margin: 1rem auto auto;
    width: 2rem;
    height: 2rem;
  }
  .submit-success {
    font-size: .36rem;
    color: #02B389;
    text-align: center;
  }
  .checking {
    font-size: .32rem;
    margin-top: 1rem;
    text-align: center;
  }
  .hint {
    font-size: .24rem;
    color: rgba(51, 51, 51, 0.5);
    margin-top: .33rem;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/checking/Checking.vue